import { FieldError, Input, Label } from 'components/core-v2/atoms'
import { useState } from 'react'
import { RegisterOptions, useFormContext } from 'react-hook-form'

import EyeClosed from '../../../../assets/eye-closed.svg?react'
import EyeOpen from '../../../../assets/eye-open.svg?react'
import { getFieldIds } from './__utils__/getFieldIds'
import fieldClasses from './field.module.scss'
import classes from './password-field.module.scss'
import { required } from './validators'

export interface PasswordFieldProps {
  'data-testid'?: string
  id: string
  isDisabled?: boolean
  label: string
  validators?: RegisterOptions
}
export const PasswordField = ({
  'data-testid': testId,
  id,
  isDisabled = false,
  label,
  validators = {}
}: PasswordFieldProps) => {
  const {
    formState: { errors },
    register
  } = useFormContext()

  const error = errors[id]?.message
  const hasError = Boolean(error)
  const { describedBy, errorId, inputId } = getFieldIds(id)

  const [type, setType] = useState('password')

  return (
    <>
      <Label className={fieldClasses.label} htmlFor={inputId}>
        {label}
      </Label>
      <div className={classes.inputWrapper}>
        <Input
          id={inputId}
          type={type}
          {...register(id, {
            ...required,
            ...validators
          })}
          data-private
          aria-describedby={describedBy}
          data-testid={testId}
          hasError={hasError}
          isDisabled={isDisabled}
        />
        <button
          aria-hidden
          aria-label="toggle password visibility"
          className={classes.eyeIcon}
          type="button"
          onMouseDown={() => setType('text')}
          onMouseUp={() => setType('password')}
        >
          {type === 'password' ? <EyeOpen /> : <EyeClosed />}
        </button>
      </div>
      {error && <FieldError id={errorId}>{String(error)}</FieldError>}
    </>
  )
}
